import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { sendRequest } from 'mt-react-common/modules/tasks/common/reducers/execDeleteMaterialsReducer';

// eslint-disable-next-line react/prefer-stateless-function
class MaterialsNotSendItem extends Component {
  render() {
    return (
      <div className="thumbnail thumbnail_no-style thumbnail_no-padding thumbnail_inline-block thumbnail_fix-size thumbnail_icon thumbnail_icon_black">
        <a
          className="thumbnail-icon-close"
          href=""
          onClick={e => {
            e.preventDefault();
            this.props.deleteMaterial();
          }}
        >
          <i className="fa fa-times" />
        </a>
        {this.props.item.fileName.match(/.(jpg|jpeg|png|gif)$/i) ? (
          <a
            className="img-fill"
            data-gallery="gallery-demo"
            data-title="Просмотр фотографии"
            data-toggle="lightbox"
            href={this.props.item.fileUrl}
            style={{
              backgroundImage: `url("${this.props.item.filePreviewUrl}")`
            }}
          >
            {' '}
          </a>
        ) : (
          <a
            className="img-fill"
            href={this.props.item.fileUrl}
            style={{
              textAlign: 'center',
              fontSize: '23px',
              paddingTop: '30px'
            }}
            download={this.props.item.fileName}
            rel="noopener noreferrer"
            target="_blank"
          >
            .{this.props.item.fileName.split('.').pop()}{' '}
            <i className="fa fa-download" aria-hidden="true" />
          </a>
        )}
        <div className="caption caption_on-img">
          <div className="text-overflow" title={this.props.item.fileName}>
            {this.props.item.fileName}
          </div>
        </div>
      </div>
    );
  }
}

MaterialsNotSendItem.propTypes = {
  // IN
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    fileName: PropTypes.string.isRequired,
    fileUrl: PropTypes.string.isRequired,
    filePreviewUrl: PropTypes.string.isRequired,
    taskExecId: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  deleteMaterial: PropTypes.func.isRequired
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = (dispatch, props) => ({
  deleteMaterial: () =>
    dispatch(
      sendRequest(props.formReduceName, props.item.taskExecId, props.item.id)
    )
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MaterialsNotSendItem)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecsMaterialsNotSendBlock/MaterialsNotSendItem.js